import {StateMap, StateConstructor, StateDescription, StateMachineConfig} from '@gongxigames/framework/slotV2/fsm/stateMachineTypes';
import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';

export class StateMachine {
    private currentStateId?: StateConstructor;

    private statesMap!: Map<StateConstructor, StateMap>;
    private config!: StateMachineConfig;

    public runStateMachine(config: StateMachineConfig): void {
        this.config = config;
        this.restartStateMachine();
    }

    public restartStateMachine(): void {
        this.stopCurrentState();

        this.statesMap = new Map();

        this.initStates(this.config.statesList);
        this.validateStates(this.config.entryStateId);
        this.goToNextState(this.config.entryStateId);
    }

    private initStates(statesList: StateDescription[]): void {
        statesList.forEach( descriptor => {
            this.addState(descriptor);
        });
    }

    private addState({state, transitions}: StateDescription): void {
        const stateInstance = state.createState();

        this.statesMap.set(state, {stateInstance, transitions});
    }

    private goToNextState(nextState?: StateConstructor) {
        nextState ??= this.getNextStateConstructor();

        this.stopCurrentState();

        if (nextState) {
            this.startState(nextState);
        }
    }

    private startState(nextStateID: StateConstructor) {
        const {stateInstance} = this.statesMap.get(nextStateID)!;

        this.currentStateId = nextStateID;
        stateInstance.activate(this.goToNextState.bind(this));
    }

    private stopCurrentState() {
        if (!this.currentStateId) {
            return;
        }

        const currentState = this.statesMap.get(this.currentStateId)?.stateInstance!;

        currentState.deactivate();
        this.currentStateId = undefined;
    }

    private getNextStateConstructor(): StateConstructor {
        const {transitions} = this.statesMap.get(this.currentStateId!)!;

        return transitions
            .find(stateId => {
                return this.statesMap
                    .get(stateId)!
                    .stateInstance.canExecute();
            })!;
    }

    private validateStates(entryStateId: StateConstructor): void {
        /* develblock:start */
        const allTransitions: StateConstructor[] = Array.from(this.statesMap.values())
            .map(value => value.transitions)
            .flat();

        this.statesMap.forEach( (value, key) => {
            value.transitions.forEach(state => {
                if (this.statesMap.get(state) === undefined) {
                    consoleLogger.error('The transition to the undefined state: ', state.ID);
                }
            });

            // TODO: refactor to stateInstance.getAct(): ActConstructor not pre crated acts
            // TODO: unnecessary creation of all acts can have some side effects in the future
            // if (value.stateInstance.act === undefined) {
            //     consoleLogger.error('The state doesnt contain act: ', key.ID);
            // }

            if (allTransitions.indexOf(key) === -1 && key !== entryStateId) {
                consoleLogger.error('The state has no transitions into it: ', key.ID);
            }
        });
        /* develblock:end */
    }
}
